
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(5 5)"}},[_c('ellipse',{attrs:{"cx":"14.157","cy":"70.743","rx":"14.157","ry":"14.189"}}),_c('path',{attrs:{"d":"M26.292 70.743V16.405a6.08 6.08 0 014.228-5.795L62.88.29c3.913-1.247 7.907 1.68 7.907 5.796v27.156","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round","fill":"none"}}),_c('path',{attrs:{"d":"M70.787 13.985l-44.495 14.19v-11.77a6.08 6.08 0 014.228-5.795L62.88.29c3.913-1.247 7.907 1.68 7.907 5.796v7.9z"}}),_c('path',{attrs:{"stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.292 28.175l44.495-14.19"}}),_c('path',{attrs:{"d":"M64.72 90C78.68 90 90 78.656 90 64.662c0-13.994-11.319-25.338-25.28-25.338-13.963 0-25.282 11.344-25.282 25.338C39.438 78.656 50.757 90 64.72 90zm-7.08-36.487v23.311l20.225-12.057L57.64 53.513z","fill-rule":"evenodd"}})])])
          )
        }
      }
    